import { CheckCircle } from "lucide-react";

import { SkeletonLoader } from "../../../common/SkeletonLoader";

import { JobCard } from "./JobCard";

export function Shortlisted({ jobs, isLoading, onJobUpdated }) {
  const shortlistedJobs = jobs.filter((job) => job.isGoodFit);

  if (isLoading) {
    return (
      <main className="flex flex-col gap-y-4">
        {Array.from({ length: 3 }).map((_, idx) => (
          <SkeletonLoader key={idx} />
        ))}
      </main>
    );
  }

  if (shortlistedJobs.length === 0) {
    return (
      <div className="flex items-center justify-center min-h-[250px]">
        <div className="flex flex-col gap-y-4 items-center justify-center text-gray-400 dark:text-gray-500">
          <CheckCircle className="size-10" />
          <h2 className="text-md  font-medium">
            Once you&apos;re shortlisted, the jobs will appear here.
          </h2>
        </div>
      </div>
    );
  }

  return (
    <main className="flex flex-col gap-y-4">
      {shortlistedJobs.map((job) => (
        <JobCard key={job.id} job={job} onJobUpdated={onJobUpdated} />
      ))}
    </main>
  );
}
